import styled from '@emotion/styled';
import { useLingui } from '@lingui/react/macro';

import { Player } from 'modules/players/domain/interfaces/player';
import { USER_DEFAULT_AVATAR } from 'shared/constants/links';
import { theme } from 'styles/theme/theme';
import { UDText } from 'ud-ui/components';
import UDLink from 'ud-ui/components/link';

/** Карточка выбранного игрока под селектом и ссылка на создание нового. Сам селект — `PlayerAsyncSelect`. */

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const InfoImage = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  object-fit: cover;
`;

export const InfoItem = ({ label, value }: { label: string; value: string | number | undefined }) => {
  return (
    <div className="flex flex-col gap-2" style={{ width: '133px' }}>
      <UDText type="subhead" color={theme.colors.SurfaceRomanSilver30}>
        {label}
      </UDText>
      <UDText type="subhead" color={theme.colors.Black} className="truncate" title={value?.toString()}>
        {value ?? '-'}
      </UDText>
    </div>
  );
};

export const Info = (props?: { player?: Player }) => {
  const { t } = useLingui();
  const player = props?.player;
  return (
    <InfoWrapper>
      <InfoImage src={player?.photo?.externalUrl ?? USER_DEFAULT_AVATAR} alt={player?.name ?? ''} />
      <InfoItem label={t`Дата рождения`} value={player?.birthDate} />
      <InfoItem label={t`Рост`} value={player?.height} />
      <InfoItem label={t`Вес`} value={player?.weight} />
    </InfoWrapper>
  );
};

export const Link = styled(UDLink)`
  text-decoration: none;
  color: ${theme.colors.LightBlue};
`;
